import styled from 'styled-components';

import { Button } from '@rover/kibble/core';

// eslint-disable-next-line rover/prefer-kibble-components
const CTAButton = styled(Button)`
  background: #be4353;
  &:hover,
  &:focus,
  &:visited {
    background: #c35361;
  }
`;

export default CTAButton;
